
export const colors = {
  primary: '#4478B5',
  button: '#5697D4',
  buttonHover: '#4A8BC6',
  secondary: '#D9A85A',
  text: '#424242',
  mutedText: '#757575',
  border: '#E0E0E0',
  footerBorder: '#E0E0E0',
  leftBackground: '#EFF7FF',
  leftBackgroundEnd: '#FFF9EF'
};

export const pageSx = {
  bgcolor: '#FFFFFF',
  color: colors.text,
  display: 'flex',
  flexDirection: 'column',
  fontFamily: 'Inter',
  minHeight: '100vh',
  margin: 0,
  maxWidth: 'none',
  overflowX: 'hidden',
  padding: 0,
  width: '100%'
};

export const headerSx = {
  bgcolor: '#FFFFFF',
  boxShadow: 'none',
  color: colors.text,
  flexShrink: 0,
  position: 'relative',
  width: '100%',
  zIndex: 2
};

export const toolbarSx = {
  alignItems: 'center',
  display: 'flex',
  gap: 2,
  height: 64,
  justifyContent: 'space-between',
  minHeight: '64px !important',
  width: '100%',
  px: {
    xs: 2,
    sm: 3,
    md: 4.5
  }
};

export const logoSx = {
  display: 'block',
  height: 'auto',
  width: {
    xs: 105,
    sm: 120
  }
};

export const accentLineSx = {
  background: `linear-gradient(
    90deg,
    ${colors.primary} 0%,
    ${colors.button} 48%,
    ${colors.secondary} 100%
  )`,
  flexShrink: 0,
  height: 4,
  width: '100%'
};

export const authBackgroundSx = {
  background: `linear-gradient(
    110deg,
    ${colors.leftBackground} 0%,
    ${colors.leftBackground} 48%,
    ${colors.leftBackgroundEnd} 100%
  )`,
  position: 'relative'
};

export const footerSx = {
  bgcolor: '#FFFFFF',
  borderTop: `1px solid ${colors.footerBorder}`,
  flexShrink: 0
};

export const footerContentSx = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  margin: '0 auto',
  minHeight: 40,
  width: '100%',
  px: {
    xs: 2,
    sm: 3,
    md: 10
  },
  py: {
    xs: 1.5,
    sm: 0
  }
};

export const footerLinksSx = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: {
    xs: 'center',
    sm: 'flex-end'
  },
  width: {
    xs: '100%',
    sm: 'auto'
  }
};

export const footerTextSx = {
  color: colors.mutedText,
  fontSize: 11,
  lineHeight: 1.5
};

export const footerDividerSx = {
  color: colors.footerBorder,
  fontSize: 10,
  mx: 1
};

export const footerLinkSx = {
  color: colors.secondary,
  fontSize: 11,
  fontWeight: 500,
  textDecoration: 'none',

  '&:hover': {
    textDecoration: 'underline'
  }
};




// SignIn


export const headerActionsSx = {
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  gap: 1.5,
  justifyContent: 'flex-end'
};

export const searchWrapperSx = {
  alignItems: 'center',
  bgcolor: '#FFFFFF',
  border: '1px solid #E1E1E1',
  borderRadius: '4px',
  display: {
    xs: 'none',
    sm: 'flex'
  },
  height: 35,
  maxWidth: 368,
  width: '100%'
};

export const searchInputSx = {
  color: colors.text,
  flex: 1,
  fontSize: 13,
  height: '100%',
  px: 1.5,

  '& input::placeholder': {
    color: '#757575',
    opacity: 1
  }
};

export const searchIconSx = {
  color: '#757575',
  height: 34,
  width: 38,

  '&:hover': {
    bgcolor: '#F5F5F5'
  },

  '& svg': {
    fontSize: 18
  }
};

export const registerButtonSx = {
  bgcolor: colors.secondary,
  borderRadius: '4px',
  boxShadow: 'none',
  color: '#FFFFFF',
  fontWeight: 500,
  height: 35,
  px: 2,
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',

  '&:hover': {
    bgcolor: '#CC963E',
    boxShadow: 'none'
  },

  '& .MuiButton-startIcon': {
    mr: 0.75
  },

  '& .MuiButton-startIcon svg': {
    fontSize: 16
  }
};

export const contentSx = {
// background: `linear-gradient(
//   90deg,
//   ${colors.leftBackground} 0%,
//   ${colors.leftBackground} 20%,
//   ${colors.leftBackgroundEnd} 100%,
// )`,
background: `linear-gradient(
    110deg,
    ${colors.leftBackground} 0%,
    ${colors.leftBackground} 48%,
    ${colors.leftBackgroundEnd} 100%
  )`,
  display: 'flex',
  flex: 1,
  position: 'relative',

  '&::before': {
    background:
      'radial-gradient(circle, rgba(68, 120, 181, 0.13) 1px, transparent 1px)',
    backgroundSize: '28px 28px',
    bottom: 30,
    content: '""',
    left: 0,
    maskImage:
      'linear-gradient(to right, rgba(0,0,0,0.9), transparent)',
    opacity: 0.6,
    position: 'absolute',
    width: '48%'
  }
};

export const mainContentSx = {
  alignItems: 'stretch', // don't use center
  display: 'grid',
  flex: 1,
  gap: {
    xs: 4,
    md: 7,
    lg: 10
  },
  gridTemplateColumns: {
    xs: '1fr',
    md: 'minmax(0, 1.2fr) minmax(360px, 0.8fr)'
  },
  margin: '0 auto',
  minHeight: {
    xs: 'auto',
    md: 'calc(100vh - 148px)',
  },
  px: {
    xs: 2,
    sm: 4,
    md: 10
  },
  py: {
    xs: 5,
    md: 2
  },
  position: 'relative',
  width: '100%',
  zIndex: 1
};

export const heroSectionSx = {
  alignItems: 'center',
  display: 'flex',
  height: {
    xs: 'auto',
    md: 'calc(100vh - 148px)'
  },
  justifyContent: {
    xs: 'center',
    md: 'flex-start'
  },
  minWidth: 0
};

export const heroContentSx = {
  maxWidth: 700,
  position: 'relative',
  width: '100%'
};

export const trustBadgeSx = {
  alignItems: 'center',
  bgcolor: '#FFFFFF',
  border: `1px solid ${colors.border}`,
  borderRadius: '18px',
  boxShadow: '0 3px 10px rgba(68, 120, 181, 0.1)',
  display: 'inline-flex',
  gap: 0.75,
  mb: 2.25,
  px: 1.2,
  py: 0.65
};

export const trustBadgeIconSx = {
  color: colors.button,
  fontSize: 16
};

export const trustBadgeTextSx = {
  color: colors.primary,
  fontSize: 11,
  fontWeight: 600
};

export const heroTitleSx = {
  color: colors.primary,
  fontSize: {
    xs: 38,
    sm: 46,
    md: 48
  },
  fontWeight: 700,
  letterSpacing: '-1.4px',
  lineHeight: 1.04,
  mb: 0
};

export const heroDescriptionSx = {
  color: colors.mutedText,
  fontSize: {
    xs: 13,
    md: 18
  },
  lineHeight: 1.4,
  maxWidth: 600
};

export const heroHeadingAccentSx = {
  background: `linear-gradient(
    90deg,
    ${colors.primary},
    ${colors.secondary}
  )`,
  borderRadius: '2px',
  height: 1.75,
  mb: 2.2,
  mt: 2.3,
  width: 120
};

export const heroCaptionSx = {
  alignItems: 'center',
  color: colors.mutedText,
  display: 'flex',
  flexWrap: 'wrap',
  fontSize: 12,
  fontWeight: 500,
  gap: 1
};

export const heroCaptionDotSx = {
  bgcolor: colors.primary,
  borderRadius: '50%',
  height: 4,
  width: 4
};

export const heroIllustrationSx = {
  height: {
    xs: 205,
    sm: 245,
    md: 270
  },
  mt: 2.5,
  position: 'relative',
  width: {
    xs: '100%',
    sm: 470,
    md: 510
  }
};

export const heroIllustrationGlowSx = {
  background:
    'radial-gradient(ellipse, rgba(86, 151, 212, 0.22), transparent 68%)',
  bottom: 0,
  filter: 'blur(4px)',
  height: 110,
  left: '6%',
  position: 'absolute',
  width: '84%'
};

export const heroIllustrationCardSx = {
  bgcolor: '#FFFFFF',
  border: `1px solid ${colors.border}`,
  borderRadius: '8px',
  bottom: 28,
  // boxShadow: '0 1px 3px rgba(16,95,161,.04),0 8px 24px rgba(16,95,161,.12)',
  boxShadow: '0 18px 35px rgba(68, 120, 181, 0.16)',
  height: {
    xs: 130,
    sm: 155,
    md: 165
  },
  left: {
    xs: '8%',
    sm: '9%'
  },
  overflow: 'hidden',
  position: 'absolute',
  transform: 'perspective(600px) rotateY(5deg) rotateX(2deg)',
  width: {
    xs: '72%',
    sm: '68%'
  }
};

export const heroIllustrationScreenSx = {
  bgcolor: '#FFFFFF',
  display: 'flex',
  gap: 1.5,
  height: '100%',
  p: 1.5
};

export const heroIllustrationLockSx = {
  alignItems: 'center',
  background: `linear-gradient(
    145deg,
    ${colors.leftBackground},
    rgba(86, 151, 212, 0.35)
  )`,
  border: '4px solid rgba(255,255,255,0.8)',
  borderRadius: '24px 24px 30px 30px',
  bottom: 25,
  boxShadow: '0 12px 25px rgba(68, 120, 181, 0.22)',
  color: colors.primary,
  display: 'flex',
  height: {
    xs: 72,
    sm: 88
  },
  justifyContent: 'center',
  position: 'absolute',
  right: {
    xs: '10%',
    sm: '15%'
  },
  width: {
    xs: 62,
    sm: 74
  },

  '& > svg:first-of-type': {
    fontSize: {
      xs: 68,
      sm: 82
    },
    position: 'absolute'
  },

  '& > svg:last-of-type': {
    color: '#FFFFFF',
    fontSize: {
      xs: 22,
      sm: 26
    },
    position: 'relative',
    zIndex: 1
  }
};

export const signInSectionSx = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: {
    xs: 'center',
    md: 'flex-end'
  },
  minWidth: 0
};

export const formWrapperSx = {
  bgcolor: '#FFFFFF',
  border: `1px solid ${colors.border}`,
  borderRadius: '12px',
  boxShadow:
    '0 14px 34px rgba(66, 66, 66, 0.09), 0 2px 6px rgba(66, 66, 66, 0.04)',
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
  
  maxWidth: 410,
  p: {
    xs: 3,
    sm: 4
  },
  width: '100%'
};

export const signInTitleSx = {
  color: colors.primary,
  fontSize: 24,
  fontWeight: 700,
  lineHeight: 1.2
};

export const signInSubtitleSx = {
  color: colors.mutedText,
  fontSize: 11,
  mt: 0,
  mb:'16px'
};

export const fieldLabelSx = {
  color: colors.text,
  display: 'block',
  fontSize: 11,
  fontWeight: 600,
  mb: 0.5,
  textTransform: 'uppercase',
  fontFamily:'Inter'
};

export const requiredSx = {
  color: '#D9534F',
  display: 'inline',
  ml: 0.3
};

export const formControlSx = {
  '& .MuiOutlinedInput-root': {
    bgcolor: '#FFFFFF',
    borderRadius: '4px',
    color: colors.text,
    fontSize: 12,
    height: 42,
    boxShadow:'none',

    '& fieldset': {
      borderColor: colors.border
    },

    '&:hover fieldset': {
      borderColor: colors.button
    },

    '&.Mui-focused fieldset': {
      borderColor: colors.primary,
      borderWidth: '1px'
    }
  },

  '& .MuiInputAdornment-root svg': {
    color: colors.mutedText,
    fontSize: 18
  },

  '& .MuiOutlinedInput-input': {
    py: 1.2
  },

  '& .MuiOutlinedInput-input::placeholder': {
    color: colors.mutedText,
    opacity: 0.7
  },

  '& .MuiFormHelperText-root': {
    fontSize: 10,
    marginLeft: 0,
    mt: 0.5
  }
};

export const passwordIconButtonSx = {
  color: colors.mutedText,
  mr: -0.5,

  '& svg': {
    fontSize: 17
  },

  '&:hover': {
    bgcolor: colors.leftBackground,
    color: colors.primary
  }
};

export const forgotLinksSx = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end',
  mt: -0.5
};

export const forgotLinkSx = {
  color: colors.primary,
  fontSize: 12,
  fontWeight: 500,
  textDecoration: 'none',

  '&:hover': {
    color: colors.buttonHover,
    textDecoration: 'underline'
  }
};

export const dividerSx = {
  color: colors.border,
  fontSize: 10,
  mx: 0.8
};

export const signInButtonSx = {
  bgcolor: colors.button,
  borderRadius: '4px',
  boxShadow: '0 4px 10px rgba(86, 151, 212, 0.22)',
  color: '#FFFFFF',
  fontSize: 11,
  fontWeight: 600,
  height: 40,
  mt: 0.5,
  textTransform: 'uppercase',

  '&:hover': {
    bgcolor: colors.buttonHover,
    boxShadow: '0 5px 14px rgba(86, 151, 212, 0.3)'
  },

  '&.Mui-disabled': {
    bgcolor: '#F5F5F5',
    color: '#757575',
    boxShadow: 'none'
  }
};

export const newPracticeSx = {
  color: colors.mutedText,
  fontSize: 10.5,
  textAlign: 'center'
};

export const registerLinkSx = {
  color: colors.secondary,
  fontSize: 12,
  fontWeight: 500,
  ml: 0.5,
  textDecoration: 'none',

  '&:hover': {
    color: colors.secondary,
    filter: 'brightness(0.88)',
    textDecoration: 'underline'
  }
};


export const footerLeftSx = {
  alignItems: 'center',
  display: {
    xs: 'none',
    sm: 'flex'
  },
  gap: 1.2
};

export const footerSecurityIconSx = {
  alignItems: 'center',
  bgcolor: colors.leftBackground,
  border: `1px solid ${colors.footerBorder}`,
  borderRadius: '50%',
  color: colors.button,
  display: 'flex',
  height: 30,
  justifyContent: 'center',
  width: 30,

  '& svg': {
    fontSize: 17
  }
};



// Register Practice



export const headerRightSx = {
  alignItems: 'center',
  display: 'flex',
  gap: 1,
  fontSize: 12,

  '& .MuiTypography-root': {
    fontSize: 12,
  }
};

export const signInLinkSx = {
  color: '#C38A32',
  fontSize: 12,
  fontWeight: 500,
  textDecoration: 'none',

  '&:hover': {
    textDecoration: 'underline'
  }
};


export const heroSx = {
  background:
    'linear-gradient(105deg, #EEF7FF 0%, #F7F8F6 57%, #FFF8EA 100%)',
  borderBottom: '1px solid #DDE4EA'
};

export const heroInnerSx = {
  width: '100%',
  maxWidth: 1510,
  minHeight: 705,
  mx: 'auto',
  px: {
    xs: 2,
    sm: 4,
    md: 7
  },
  py: {
    xs: 5,
    md: 2
  },

  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    lg: '1.55fr 1fr'
  },
  alignItems: 'center',
  gap: {
    xs: 5,
    lg: 9
  }
};


export const registrationCardSx = {
  backgroundColor: '#FFFFFF',
  border: '1px solid #DEDEDE',
  borderRadius: '18px',
  boxShadow:
    '0 12px 28px rgba(31, 41, 55, 0.15)',
  minHeight: 625,
  p: {
    xs: 2.5,
    sm: 3.5
  },
  display: 'flex',
  flexDirection: 'column'
};

export const registrationTitleSx = {
  color: '#437DBD',
  fontSize: 30,
  fontWeight: 700,
  lineHeight: 1.2,
  mb: 0.75
};

export const registrationDescriptionSx = {
  color: '#707070',
  fontSize: 14,
  lineHeight: 1.25,
  maxWidth: 500,
  mb: 2
};

export const stepHeaderSx = {
  backgroundColor: '#F8FAFD',
  border: '1px solid #E0E0E0',
  borderRadius: '7px',
  px: 2,
  py: 1.2,
  mb: 2
};

export const stepNumberSx = {
  color: colors.mutedText,
  fontSize: 12,
  lineHeight: 1.2
};

export const stepTitleSx = {
  color: '#424242',
  fontSize: 18,
  fontWeight: 600,
  lineHeight: 1.3
};

export const formGridSx = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))'
  },
  columnGap: 1.7,
  rowGap: 2
};

export const fieldSx = {
  minWidth: 0
};


export const inputSx = {
  width: '100%',
  height: 42,
  borderRadius: '6px',
  backgroundColor: '#FFFFFF',

  '& .MuiOutlinedInput-input': {
    boxSizing: 'border-box',
    height: 42,
    px: 1.5,
    py: 0,
    fontSize: 14
  },

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8C8C8'
  },

  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#AFAFAF'
  },

  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#5A9BD5',
    borderWidth: 1
  },

  '& .MuiIconButton-root': {
    color: '#717171'
  }
};

export const selectSx = {
  height: 42,
  borderRadius: '6px',
  fontSize: 14,

  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8C8C8'
  },

  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#AFAFAF'
  },

  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#5A9BD5',
    borderWidth: 1
  }
};

export const formActionsSx = {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 1.5,
  mt: 'auto',
  pt: 0,

  '& .MuiButton-root': {
    borderRadius: '7px',
    height: 38,
    minWidth: 100,
    fontSize: 12,
    fontWeight: 600
  },

  '& .MuiButton-outlined': {
    borderColor: '#BFDDF6',
    color: '#4283C4',

    '&:hover': {
      backgroundColor: '#F5FAFF',
      borderColor: '#81B9E8'
    }
  },

  '& .MuiButton-contained': {
    backgroundColor: '#569BD7',
    boxShadow:
      '0 5px 10px rgba(65, 145, 210, 0.25)',

    '&:hover': {
      backgroundColor: '#468AC6'
    }
  }
};

export const marketingSectionSx = {
  backgroundColor: '#F5F8FC',
  borderBottom: '1px solid #DEE3E8',
  py: 7
};

export const marketingInnerSx = {
  maxWidth: 1510,
  mx: 'auto',
  px: {
    xs: 3,
    md: 7
  },
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    md: '1fr 1.2fr'
  },
  alignItems: 'center',
  gap: 7
};

export const productImageSx = {
  display: 'block',
  width: '100%',
  maxWidth: 620,
  mx: 'auto',
  objectFit: 'contain'
};

export const sectionEyebrowSx = {
  color: '#4E8AC7',
  fontSize: {
    xs: 18,
    md: 20
  },
  fontWeight: 400,
  mb: 2
};

export const sectionTitleSx = {
  color: '#424242',
  fontSize: {
    xs: 28,
    md: 32
  },
  fontWeight: 500,
  lineHeight: 1.3
};

export const capabilitySectionSx = {
  backgroundColor: '#FFFFFF',
  borderBottom: '1px solid #E0E4E8',
  py: 6
};

export const capabilityInnerSx = {
  maxWidth: 1510,
  mx: 'auto',
  px: {
    xs: 3,
    md: 7
  },
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    lg: '1.1fr 1fr'
  },
  gap: 6,
  alignItems: 'center'
};

export const capabilityListSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5
};

export const capabilityItemSx = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1.4,
  color: '#424242',

  '& > svg': {
    color: '#727272',
    fontSize: 30,
    mt: 0.2
  },

  '& .MuiTypography-root': {
    fontSize: {
      xs: 20,
      md: 26
    },
    fontWeight: 500,
    lineHeight: 1.25
  }
};

export const statCardsSx = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(3, 1fr)'
  },
  gap: 2.5
};

export const statCardSx = {
  border: '5px solid #FFFFFF',
  borderRadius: '20px',
  boxShadow:
    '0 4px 15px rgba(0,0,0,0.12)',
  minHeight: 270,
  px: 2,
  py: 3,
  textAlign: 'center'
};

export const statIconSx = {
  width: 78,
  height: 78,
  borderRadius: '50%',
  mx: 'auto',
  mb: 2,
  backgroundColor: '#FFFFFF',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '& svg': {
    fontSize: 42
  }
};

export const statValueSx = {
  color: '#3571B1',
  fontSize: 44,
  fontWeight: 700,
  lineHeight: 1
};

export const statTextSx = {
  color: '#376EA7',
  fontSize: 17,
  lineHeight: 1.15,
  mt: 1
};

export const practiceSectionSx = {
  backgroundColor: '#F5F8FC',
  borderBottom: '1px solid #DDE3E8',
  py: 6
};

export const practiceInnerSx = {
  maxWidth: 1510,
  mx: 'auto',
  px: {
    xs: 3,
    md: 7
  },
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    md: '1fr 1.3fr'
  },
  alignItems: 'center',
  gap: 6
};

export const faqSectionSx = {
  maxWidth: 1510,
  width: '100%',
  mx: 'auto',
  px: {
    xs: 3,
    md: 7
  },
  py: 6,
  textAlign: 'center'
};

export const faqTitleSx = {
  color: '#414141',
  fontSize: {
    xs: 30,
    md: 38
  },
  fontWeight: 600,
  mb: 5
};

export const faqGridSx = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    md: '1fr 1fr'
  },
  gap: {
    xs: 0,
    md: 7
  },
  textAlign: 'left'
};

export const faqColumnSx = {
  minWidth: 0
};

export const faqItemSx = {
  borderBottom: '1px solid #DDDDDD'
};

export const faqQuestionSx = {
  color: '#AE8648',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: 64,

  '& .MuiTypography-root': {
    fontSize: {
      xs: 18,
      md: 22
    },
    fontWeight: 500
  },

  '& svg': {
    color: '#666666'
  }
};

export const faqAnswerSx = {
  color: '#535353',
  fontSize: 17,
  lineHeight: 1.4,
  pb: 2.5
};

export const trialCardSx = {
  backgroundColor: '#F8FAFD',
  border: '1px solid #C1DEF2',
  borderRadius: '14px',
  mt: 6,
  py: {
    xs: 5,
    md: 7
  },
  px: 3,
  textAlign: 'center',

  '& .MuiButton-root': {
    backgroundColor: '#5697D4',
    borderRadius: '6px',
    mt: 3,
    px: 3.5,
    height: 48,
    fontWeight: 600
  }
};

export const trialTitleSx = {
  color: '#4478B5',
  fontSize: {
    xs: 29,
    md: 32
  },
  fontWeight: 600,
  mb: 2.5
};

export const trialDescriptionSx = {
  color: '#616161',
  fontSize: {
    xs: 17,
    md: 20
  }
};

/* Agreement */

export const agreementPageSx = {
  background:
    'linear-gradient(105deg, #EEF7FF 0%, #F7F8F6 57%, #FFF8EA 100%)',

  flex: 1,

  px: {
    xs: 2,
    md: 6
  },

  py: {
    xs: 4,
    md: 6.5
  },

  minHeight: 0,
  overflow: 'hidden'
};

export const agreementCardSx = {
  width: '100%',
  maxWidth: 1180,

  height: '70vh',
  maxHeight: '70vh',
  minHeight: 0,

  mx: 'auto',

  backgroundColor: '#FFFFFF',

  border: '1px solid #DEDEDE',
  borderRadius: '18px',

  boxShadow:
    '0 12px 25px rgba(31,41,55,.15)',

  px: {
    xs: 3,
    md: 4
  },

  py: 4,

  display: 'flex',
  flexDirection: 'column',

  overflow: 'hidden'
};

export const agreementTitleSx = {
  flexShrink: 0,

  color: '#4478B5',

  fontSize: {
    xs: 26,
    md: 30
  },

  fontWeight: 700,

  mb: 3
};

export const agreementContentSx = {
  flex: 1,
  minHeight: 0,

  color: '#424242',

  display: 'flex',
  flexDirection: 'column',

  gap: 1.5,

  // Scroll enabled
  overflowY: 'auto',
  overflowX: 'hidden',

  pr: 1,

  // Hide scrollbar - Firefox
  scrollbarWidth: 'none',

  // Hide scrollbar - IE / Edge legacy
  msOverflowStyle: 'none',

  // Hide scrollbar - Chrome / Edge / Safari
  '&::-webkit-scrollbar': {
    display: 'none',
    width: 0,
    height: 0
  },

  '& .MuiTypography-root': {
    flexShrink: 0,

    fontSize: 14,
    lineHeight: 1.25
  }
};

export const agreementActionsSx = {
  flexShrink: 0,

  display: 'flex',
  justifyContent: 'flex-end',

  gap: 1.5,

  pt: 2.5,

  backgroundColor: '#FFFFFF',

  '& .MuiButton-root': {
    height: 42,

    minWidth: 135,

    borderRadius: '6px',

    fontWeight: 600
  },

  '& .MuiButton-outlined': {
    borderColor: '#B8D8F3',
    color: '#5697D4'
  },

  '& .MuiButton-contained': {
    backgroundColor: '#5697D4'
  }
};

/* Confirmation */

export const confirmationPageSx = {
  flex: 1,
  minHeight: 'calc(100vh - 120px)',
  background:
    'linear-gradient(105deg, #EEF7FF 0%, #F7F8F6 57%, #FFF8EA 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  px: 2,
  py: 5
};

export const confirmationCardSx = {
  width: '100%',
  maxWidth: 455,
  backgroundColor: '#FFFFFF',
  border: '1px solid #DEDEDE',
  borderRadius: '16px',
  boxShadow:
    '0 12px 25px rgba(31,41,55,.15)',
  p: 3.5,
  textAlign: 'center',

  '& .MuiButton-root': {
    height: 43,
    mt: 2,
    backgroundColor: '#579BD7',
    fontWeight: 500
  }
};

export const successIconOuterSx = {
  width: 80,
  height: 80,
  borderRadius: '50%',
  backgroundColor: '#EFF8EF',
  mx: 'auto',
  mb: 4,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const successIconSx = {
  width: 100,
  height: 100,
  borderRadius: '50%',
  // // backgroundColor: '#49A84E',
  // color: '#FFFFFF',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '& svg': {
    fontSize: 100,
    strokeWidth: 2
  }
};

export const confirmationTitleSx = {
  color: '#424242',
  fontSize: 22,
  fontWeight: 500,
  mb: 3
};

export const confirmationTextSx = {
  color: '#424242',
  fontSize: 14,
  lineHeight: 1.3,
  mb: 1
};


export const registerHeroContentSx = {
  maxWidth: 760
};

export const registerHeroTitleSx = {
  color: '#437DBD',
  fontSize: {
    xs: 38,
    sm: 48,
    lg: 46
  },
  fontWeight: 700,
  lineHeight: 1.15,
  letterSpacing: '-1px',
  mb: 3
};

export const registerHeroDescriptionSx = {
  color: '#434343',
  fontSize: {
    xs: 19,
    md: 25
  },
  lineHeight: 1.42,
  maxWidth: 750
};

export const registerFieldLabelSx = {
  color: '#555555',
  display: 'block',
  fontSize: 11.5,
  fontWeight: 500,
  mb: 0.7
};